import React from 'react'
import { Link } from 'react-router-dom'
import Typography from 'material-ui/Typography'
import Grid from 'material-ui/Grid'
import TextField from 'material-ui/TextField'
import Button from 'material-ui/Button'
import { withStyles } from 'material-ui/styles'
import styles from './styles'
import history from '../../history'
import LanguageSelector from '../i18/languageSelector'
import packageJson from '../../../package.json';
import {APP_CONFIG} from "../../config";
import MFADialog from "../common/mfaDialog";
import InputPasswordField from "../common/inputpassword"
import HCaptcha from '@hcaptcha/react-hcaptcha';

const DELAY = 1500;

// Map language to ISO 639-1 Code
const mapLanguageToCaptchaLanguage = language => {
  switch (language) {
    case 'en-UK':
    case 'en-US':
      return 'en';
    case 'jp-JP':
      return 'ja';
    case 'zh-CN':
      return 'zh';
    case 'de-DE':
      return 'de';
    case 'fr-FR':
      return 'fr';
    case 'it-IT':
      return 'it';
    case 'pt-PT':
      return 'pt';
    case 'es-ES':
      return 'es';
    case 'ru-RU':
      return 'ru';
    case 'pl-PL':
      return 'pl';
    default:
      return 'en';
  }
}

class LoginForm extends React.Component {

  state = {
    username: '',
    password: '',
    anchorEl: null,
    error: false,
    mfaDialogOpen: false,
    reCaptchaLanguageCode: 'en',
    reCaptchaLoad: false,
    reCaptchaValid: false,
    submitting: false
  }

  componentDidMount() {
    this.clearCache();

    setTimeout(() => {
      this.setState({
        reCaptchaLanguageCode: mapLanguageToCaptchaLanguage(this.props.activeLanguage),
        reCaptchaLoad: true
      });
    }, DELAY);


  }

  componentWillReceiveProps(nextProps) {
    const { mfaVerificationRequested } = nextProps
    if (mfaVerificationRequested ) {
      this.setState({
        mfaDialogOpen: true
      })
    }
  }

  closeMfaModal = () => {
    this.setState({
      mfaDialogOpen: false
    })
  }

  onCaptchaValueChange = (value) => {
    if (value) {
      this.setState({ reCaptchaValid: true });
    } else {
      this.setState({ reCaptchaValid: false });
    }
  }

  handleVerificationSuccess = (token, ekey) => {
    if (token) {
      this.setState({ reCaptchaValid: true });
    } else {
      this.setState({ reCaptchaValid: false });
    }
  }

  clearCache = ()=> {
    const storageKey = 'trend-version';
    let version = localStorage.getItem(storageKey);

    if(version !== packageJson.version) {
      if('caches' in window) {
          caches.keys().then((names) => {
            names.forEach(name => {
                caches.delete(name);
            })
        });

        window.location.reload(true);
      }

      localStorage.removeItem(storageKey);
      localStorage.setItem(storageKey, packageJson.version);
    }
  };

  handleChange = (name) => event => {
    this.setState({
      error: false,
      [name]: event.target.value,
    });
    this.props.clearAuthError();
  };

  handleSubmit(e) {
    e.preventDefault()
    if (this.state.submitting) return

    if (this.state.username !== '' && this.state.password !== '') {
      this.setState({ submitting: true }, () => {
        this.props.login({
        username: this.state.username,
        password: this.state.password,
        grant_type: 'password'
        }).finally(() => this.setState({ submitting: false }))
      })
    } else {
      this.setState({ error: true })
    }
  }

  handleLanguageChange = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  }

  handleLanguageChangeClose = (language) => {
    this.setState({anchorEl: null})

    if (typeof (language) === 'string') {
      this.props.setLanguage(language)

      this.setState({reCaptchaLanguageCode: mapLanguageToCaptchaLanguage(language)});
    }
  }

  render() {

    const {
      classes,
      translate,
      valid,
      activeLanguage,
      languages,
      authErrorMessage,
    } = this.props

    let $mfaModal = null
    if (this.state.mfaDialogOpen) {
      $mfaModal = (
        <MFADialog
          open={this.state.mfaDialogOpen}
          closeMfaDialog={this.closeMfaModal}
          sendOtp={this.props.sendOtp}
          verifyOtp={this.props.verifyOtp}
          emailAddress={this.props.mfaUsername}
          activeLanguage={activeLanguage}
          translate={translate}
          mfaError={this.props.mfaError}
        />
      )
    }
    return (

      <div className={classes.root}>
        <form noValidate autoComplete="off" className={classes.formWrapper}>
          <Grid container className={classes.loginPage}>

            <Grid item className={classes.bigBlue} xs={6}>
              <Grid item className={classes.logo}>
                <img alt="" className={classes.image} src={'/images/login_logo.svg'} />
              </Grid>
              <Grid item className={classes.gears}>
                <img className={classes.image} alt="" src={'/images/gear.svg'} />
              </Grid>
            </Grid>
            <Grid item className={classes.loginRight} xs={6}>
              <Grid item className={classes.loginContainer}>
                <Grid item xs={10}>
                  <Typography type="headline" className={classes.headline} color="primary">
                    {translate('login_welcome')}
                  </Typography>
                  {
                    (valid)
                      ? <Valid translate={translate} />
                      : <Invalid translate={translate} errorMessage={authErrorMessage} />
                  }
                </Grid>
                <Grid item xs={2} className={classes.langSelect}>
                  <LanguageSelector
                    handleLanguageChange={this.handleLanguageChange}
                    handleLanguageChangeClose={this.handleLanguageChangeClose}
                    anchorEl={this.state.anchorEl}
                    activeLanguage={activeLanguage}
                    languages={languages}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    error={this.state.error}
                    required
                    id="username"
                    label={translate('login_username')}
                    className={classes.textField}
                    fullWidth
                    onChange={this.handleChange('username')}
                    value={this.state.username}
                    autoFocus
                  />
                </Grid>
                <Grid item xs={12}>
                  <InputPasswordField
                    id="password"
                    label={translate('login_password')}
                    autoComplete="current-password"
                    onChange={this.handleChange('password')}
                    value={this.state.password}
                    error={this.state.error}
                    classes={classes.textField}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Button
                    type="submit"
                    color="primary"
                    raised
                    disabled={!this.state.reCaptchaValid || this.state.submitting}
                    onClick={(e) => this.handleSubmit(e)}
                    className={classes.loginButton}
                  >
                    {translate('login_login')}
                  </Button>
                  <Typography className={classes.forgot} align="center">
                    <Link to="/forgot">{translate('forgot_password_help')}</Link>
                  </Typography>
                </Grid>
                <Grid item xs={12} style={{ height: '80px' }}>

                  {this.state.reCaptchaLoad && (

                    <HCaptcha
                      languageOverride={this.state.reCaptchaLanguageCode}
                      sitekey={APP_CONFIG.reCaptchaSiteKey}
                      onVerify={(token,ekey) => this.handleVerificationSuccess(token, ekey)}
                    />
                  )}
                </Grid>

              </Grid>
              <Grid item className={classes.signUp} xs={12}>
                <Typography type="headline" className={classes.headline}>
                  {translate('signup_welcome')}
                </Typography>
                <Grid item className={classes.marginBottom}>
                  <Typography className={classes.medium}>
                    {translate('signup_welcome_text')}
                  </Typography>
                </Grid>
                <Grid item className={classes.signupText}>
                  <Typography>
                  </Typography>
                </Grid>
                <Grid item>
                  <Button
                    type="submit"
                    color="primary"
                    raised
                    className={classes.signupButton}
                    onClick={() => history.push('/signup')}
                  >
                    {translate('signup_here')}
                  </Button>
                </Grid>
                <Grid item xs={12} className={classes.downloadDesktop}>
                  {translate("download_desktop_link")}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </form>
        {$mfaModal}
      </div>
    )
  }
}

const Valid = ({ translate }) => (
  <Typography gutterBottom>
    {translate('login_message')}
  </Typography>
)

const Invalid = ({ translate, errorMessage }) => (
  <Typography color="error" gutterBottom>
    {translate(errorMessage || 'login_error')}
  </Typography>
)

export default withStyles(styles)(LoginForm)
